import { Link, useNavigate } from 'react-router-dom';
import { Settings, LogOut } from 'lucide-react';
import { TenantSelector } from './TenantSelector';
import { useTenant, useIsSuperAdmin, useHasRole } from '@paulownia/shared/lib/tenant-context';
import { Button } from '@paulownia/shared/components/ui/button';
import { signOut } from '@paulownia/shared/lib/auth';
import { toast } from 'sonner';

export function TopBar() {
  const navigate = useNavigate();
  const { user, loading, claims, currentTenantId } = useTenant();
  const isSuperAdmin = useIsSuperAdmin();
  const isOwner = useHasRole('owner');

  if (loading || !user) {
    return null;
  }

  // Check if user has tenants
  const hasTenants = isSuperAdmin || (claims?.tenantIds && claims.tenantIds.length > 0);

  // Show settings for owner role users or superadmins
  const canAccessSettings = isOwner || isSuperAdmin;

  const handleLogout = async () => {
    try {
      await signOut();
      toast.success('Déconnexion réussie');
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
      toast.error('Erreur lors de la déconnexion');
    }
  };

  return (
    <div className="fixed top-0 inset-x-0 z-40 border-b bg-white shadow-sm">
      <div className="flex items-center justify-between gap-2 px-2 sm:px-4 py-2 min-h-[48px]">
        {/* Left side - Settings */}
        <div className="flex items-center gap-1 sm:gap-2 flex-shrink-0">
          {hasTenants && isSuperAdmin && (
            <Link to="/admin">
              <Button variant="ghost" size="sm" className="gap-1 sm:gap-2 px-2 sm:px-3">
                <Settings className="h-4 w-4" />
                <span className="hidden sm:inline">Admin</span>
              </Button>
            </Link>
          )}
          {hasTenants && canAccessSettings && currentTenantId && (
            <Link to="/settings">
              <Button variant="ghost" size="sm" className="gap-1 sm:gap-2 px-2 sm:px-3">
                <Settings className="h-4 w-4" />
                <span className="hidden xs:inline">Paramètres</span>
              </Button>
            </Link>
          )}
        </div>

        {/* Right side - Tenant + Logout */}
        <div className="flex items-center gap-1 sm:gap-2 min-w-0">
          {hasTenants && <TenantSelector />}
          <Button
            variant="ghost"
            size="sm"
            onClick={handleLogout}
            className="text-gray-500 hover:text-red-600 flex-shrink-0 px-2"
          >
            <LogOut className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
